export const errorsToIgnoreInSentry = [
  "AbortError: The play() request was interrupted by a call to pause()",
  "Array.from requires an array-like object - not null or undefined",
  "Cannot read properties of null (reading '__transferData')",
  "Cannot read properties of null (reading 'index')",
  "Cannot read properties of null (reading 'removeItem')",
  "Cannot read properties of null (reading 'setItem')",
  "Cannot read properties of undefined (reading 'audioVolumeChange')",
  "Cannot read properties of undefined (reading 'domInteractive')",
  "Cannot read properties of undefined (reading 'fireChangeEvent')",
  "Cannot read properties of undefined (reading 'fireEvent')",
  "Cannot read properties of undefined (reading 'fireReadyEvent')",
  "Cannot read properties of undefined (reading 'offsetHeight')",
  "Cannot read properties of undefined (reading 'parentNode')",
  "Cannot read properties of undefined (reading 'setCurrentPosition')",
  "Cannot read properties of undefined (reading 'setDefaultPosition')",
  "Cannot read properties of undefined (reading 'setMaxSize')",
  "Cannot read properties of undefined (reading 'setScreenSize')",
  "Cannot read property 'index' of null",
  "Cannot set properties of null (setting 'lastSetTimerId')",
  "Cannot set properties of undefined (setting 'lastSetTimerId')",
  "error loading dynamically imported module:",
  "Event `CustomEvent` (type=unhandledrejection) captured as promise rejection",
  "Failed to fetch",
  "Failed to read the 'localStorage' property from 'Window': Access is denied for this document",
  "Importing a module script failed",
  "Invalid call to runtime.sendMessage(). Tab not found",
  "is not defined",
  "Java bridge method invocation error",
  "Java object is gone",
  "Load failed",
  "No error message",
  "Non-Error promise rejection captured with value:",
  "null is not an object (evaluating 'document.elementFromPoint(",
  "null is not an object (evaluating 'history.state.index')",
  "null is not an object (evaluating 'r.createElement')",
  "Object captured as promise rejection with keys:",
  "scrollReadRandom(...) is not a function",
  "t is not a function",
  "The operation is insecure.",
  "undefined is not a function",
  "undefined is not an object (evaluating 'this._perf.domInteractive')",
  "undefined is not an object (evaluating 'window.webkit.messageHandlers",
  "window.mainThread.webWorker.postMessage is not a function",
]; 

export const errorTypesToIgnoreInSentry = [
  "<unknown>",
  "Error",
  "ReferenceError",
  "UnhandledRejection",
];